<template>
    <vs-button class="delta ml-0 size-12" style="max-height: 35px;" color="success" vs-type="flat" vs-icon="arrow_upward" v-if="delta > 0">{{delta}}%</vs-button>
    <vs-button class="delta ml-0 size-12" style="max-height: 35px;" color="danger" vs-type="flat" vs-icon="arrow_downward" v-else>{{delta}}%</vs-button>
</template>
<script>
export default {
    props:['delta']
}
</script>
